import { Col } from 'react-bootstrap'
import { DashboardTable } from '../../commonDashboardComponents/DashboardTable'

export const CEOInvoiceSnap = ({ data }) => {
    const invoiceCardData = data && data.map(c => ({
        invoiceNumber: c?.invoice_number,
        invoiceDate: c?.invoice_date,
        customerName: c?.contact_name,
        amount: c?.total_amount
    }))

    const invoiceTableHeader = () => (<thead style={{ zIndex: 10 }}>
        <tr style={{ textAlign: "start" }}>
            <th scope="col" className='d-table-cell' style={{ background: 'white', fontSize: '12px' }}>
                Invoice Number
            </th>
            <th scope="col" className='d-table-cell' style={{ background: 'white', fontSize: '12px' }}>
                Invoice Date
            </th>
            <th scope="col" className='d-table-cell' style={{ background: 'white', fontSize: '12px' }}>
                Customer Name
            </th>
            <th scope="col" className='d-table-cell' style={{ background: 'white', fontSize: '12px' }}>
                Amount
            </th>
        </tr>
    </thead>)

    const invoiceTableBody = () => (
        invoiceCardData.map((invoice, idx) => (
            <tr key={idx}>
                <td className="fw-semibold text-dark">{invoice.invoiceNumber}</td>
                <td className="text-muted">{invoice.invoiceDate}</td>
                <td className="text-muted">{invoice.customerName}</td>
                <td className="fw-semibold text-dark">{invoice.amount}</td>
            </tr>
        ))
    )

    return (
        <Col lg={5}>
            <DashboardTable
                title={"Invoice Generated"}
                subheader={"A snapshot of today's generated invoice orders."}
                tableHeader={invoiceTableHeader}
                tableBody={invoiceTableBody}
                dataLength={data ? data?.length : 0}
            />
        </Col>
    )
}
